import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import { IntInput } from "components/Input/Index.js";
import Button from "components/CustomButtons/Button.js";
import useActionTable from "./useActionTable.js";
import {targetedenergyList} from "variables/lists/action";

const useStyles = makeStyles(styles);

const PercentageOFEco = ({ oldValue, earnings }) => {
  let result = new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 3}).format((oldValue && earnings) ? ((earnings / oldValue) * 100) : 0);
  return <div>{result}</div>;
};

const RTSimpleSavings = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  const classes = useStyles();

  const columns = [
    {
      name: "Fluide",
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
    //  cell: (row) => targetedenergyList.find((x) => x.id == row.energy)?.name || ""
    },
    {
      name: "Economies (MWh ou m3)",
      selector: (row) => row.earnings,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            intInput={newData[indexFinder(row.id)].earnings}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="earnings"
          />
        ) : (
          row.earnings
        ),
    },
    {
      name: "Economies (%)",
      selector: (row) => row.value,
      sortable: true,
      cell: (row) => (
        <div>
          <PercentageOFEco oldValue={row.value} earnings={row.earnings} />
        </div>
      ),
    },
    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer l'impact">
              <Button
                onClick={editEnabled(row)}
                color={editableRowId === row.id ? "info" : "success"}
                className={classes.actionButton}
              >
                {editableRowId === row.id ? (
                  <CheckIcon fontSize="large" />
                ) : (
                  <EditIcon fontSize="large" />
                )}
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  const editEnabled = (row) => async () => {
    editableRowId === row.id
      ? setEditableRowId(null)
      : setEditableRowId(row.id);
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Simulation"
        subHeader
        noDataComponent="Aucune simulation trouvée"
        columns={columns}
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        {...gridState}
      />
    </>
  );
};

export default RTSimpleSavings;
